module.exports = __webpack_public_path__ + "img/address.0261e9c4.svg";